/**
 * Query-key prefix for `POST /evaluation_cases/:id/run_scenarios` on the eval page. Here so the case
 * page can invalidate it after a save, without importing the eval page's hooks.
 */
export const RUN_SCENARIOS_QUERY_KEY = 'eval3-new:run-scenarios' as const;

/**
 * Query-key prefix for `GET /evaluation_cases/:id`, read under one key by the case page and the
 * eval page (caseQueryOptions in lib/evaluation-case/case-query), so a save on one reaches the other.
 */
export const CASE_QUERY_KEY = 'evaluation-case';
